import { render } from "./ButtonsWithBackgroudColor.vue?vue&type=template&id=d1d5e406"
import script from "./ButtonsWithBackgroudColor.vue?vue&type=script&lang=js"
export * from "./ButtonsWithBackgroudColor.vue?vue&type=script&lang=js"
script.render = render

export default script